import { z } from 'zod';

const identifier = z
  .string()
  .min(1)
  .max(80)
  .regex(/^[a-zA-Z0-9_-]+$/);
const label = z.string().min(1).max(40);
const action = { id: identifier, label };

const FeedbackActionSchema = z.object({
  ...action,
  kind: z.literal('feedback'),
  trigger: z.enum(['button', 'close']).optional(),
  question: z.string().min(1).max(160),
  options: z
    .array(z.object({ id: identifier, label: z.string().min(1).max(80) }))
    .min(2)
    .max(4),
  skip_label: label,
  confirmation: z.string().min(1).max(120),
  dismiss_after: z.boolean(),
});

export const SuggestionChipSchema = z.object({
  schema_version: z.literal(1),
  experiment_id: identifier,
  variant_id: identifier,
  revision: z.string().min(1).max(80),
  message: z.string().min(1).max(240),
  primary: z.discriminatedUnion('kind', [
    z.object({ ...action, kind: z.literal('connect') }),
    z.object({
      ...action,
      kind: z.literal('start_chat'),
      prompt: z.string().min(1).max(2000),
    }),
  ]),
  secondary: z
    .discriminatedUnion('kind', [
      z.object({ ...action, kind: z.literal('dismiss') }),
      FeedbackActionSchema,
    ])
    .nullable(),
});

export type SuggestionChip = z.infer<typeof SuggestionChipSchema>;
export type SuggestionFeedbackAction = z.infer<typeof FeedbackActionSchema>;
